import {Component, OnDestroy, OnInit} from '@angular/core';
import {DirectoryService} from '../../services/directory.service';
import {UrlService} from '../../services/url.service';
import {AmenitiesService} from '../../services/amenities.service';
import {ParkingPassService} from '../../services/parking-pass.service';
import {ActivatedRoute} from '@angular/router';
import {CondomanagerService} from '../../services/condomanager.service';
import {flatMap, switchMap, takeUntil, tap} from 'rxjs/operators';
import {Subject} from 'rxjs/Subject';
import {untilDestroyed} from 'ngx-take-until-destroy';

declare const $: any;
declare const toastr: any;

@Component({
    templateUrl: 'directory.component.html'
})

export class DirectoryComponent implements OnInit, OnDestroy {
    currentTabId: string;
    tabTitles = {
        'residents': 'Residents',
        'units': 'Units',
        'parking-spots': 'Parking Spots',
        'lockers': 'Lockers',
        'vehicles': 'Vehicles',
        'pets': 'Pets',
        'bike-racks': 'Bike Racks',
        'vendors': 'Vendors',
        'updates': 'Updates',
    };

    constructor(
        public directoryService: DirectoryService,
        public urlService: UrlService,
        public amenitiesService: AmenitiesService,
        public parkingPassService: ParkingPassService,
        public condomanagerService: CondomanagerService,
        public router: ActivatedRoute
    ) {
    }

    ngOnInit() {
        this.urlService.getQueryParams();
        this.urlService
            .onUrlChange
            .pipe(
                tap(
                    () => {
                        this.directoryService.showDetailedView = false;
                        this.directoryService.currentTabId = this.currentTabId = this.urlService.queryParams['tab'];
                    }
                ),
                switchMap(() => {
                    return this.directoryService.getDataByQueryParams(true);
                }),
                tap(() => {
                    if (this.directoryService.buildings.length > 1) {
                        this.directoryService.selectedBuilding = this.urlService.queryParams.building;
                    }
                }),
                untilDestroyed(this)
            )
            .subscribe();

        this.directoryService
            .onDataReceived
            .subscribe(data => {
                if ($('.table')[0] && data.scrollToTop)
                    $('.table')[0].scrollIntoView();
            });

        this.directoryService
            .onDataUpdated
            .subscribe(() => {
                this.urlService.setQueryParams();
            });
        this.directoryService.getBuildings();
        this.directoryService.getGroups();
        this.directoryService.getCountries();
        this.directoryService.getOccupancyTypes();

        this.directoryService.getCorporations();
        this.directoryService.getVendorsCategories();
        this.directoryService.getVendorsPaymentMethods();

        if (this.userIsSuperAdmin()) {
            this.directoryService.directoryData.vendors.get = '/v1/vendors?expand=serviceAreas';
        }

        // resolves a visibility of the update tab
        this.directoryService.directoryData.updates.total = this.router.snapshot.data.updatesCount;

        this.urlService.setQueryParams(this.getInitTabId());
    }

    ngOnDestroy() {
        this.removeAllObservers();
        this.directoryService.resetDirectoryData();
        let archived = false;
        if (window.location.hash.indexOf('directory') != -1)
            archived = this.urlService.queryParams['show_moved_out'];
        this.urlService.resetQueryParams();
        if (archived)
            this.urlService.queryParams['show_moved_out'] = true;
    }

    /**
     * Returns tab ID for initial state
     */
    private getInitTabId() {
        if (this.directoryService.directoryData[this.urlService.queryParams.tab]) {
            return this.urlService.queryParams.tab;
        }

        return this.router.snapshot.data.updatesCount ? 'updates' : 'residents';
    }

    getActiveTabTitle() {
        const tabId = this.urlService.queryParams['tab'];
        return this.tabTitles[tabId] ? this.tabTitles[tabId].slice(0, -1) : '';
    }

    removeAllObservers() {
        this.directoryService.onDataReceived.observers = [];
        this.directoryService.onDataSend.observers = [];
        this.directoryService.onDataUpdated.observers = [];
        this.directoryService.onToggleDetailedView.observers = [];
        this.urlService.onUrlChange.observers = [];
    }

    userIsSuperAdmin() {
        const userType = localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData')).userType : '';
        return userType == 'super_admin';
    }

    showArchivedItemsFilter() {
        return this.currentTabId == 'residents' || this.currentTabId == 'vehicles' || this.currentTabId == 'pets';
    }
}





// WEBPACK FOOTER //
// /app/src/app/views/directory/directory.component.ts